import { apiGetAuth, apiPutAuth } from '@/utils/api'
import { API_SETTING } from '@/utils/api-url'
import {
  notificationDanger
} from '@/utils/notification'

const state = () => {
  return {
    general_setting: { data: [] },
    meta_filter: {},
    data_modal_add_edit: {},
    toggle_modal_add_edit_discard: {
      targetModals: false,  
      title: '', 
      description: '',
      customTitleBtnOk: '',
      customClass: '',
      type: '',
      loading: false
    }
  }
}

const mutations = {
  SET_GENERAL_SETTING (state, payload) {
    state.general_setting = payload
  },
  SET_DATA_MODAL_ADD_EDIT (state, payload) {
    state.data_modal_add_edit = payload
  },
  SET_TOGGLE_MODAL_ADD_EDIT_DISCARD (state, payload) {
    state.toggle_modal_add_edit_discard = payload
  }
}

const actions = {
  async getGeneralSetting (context, payload) {
    try {
      const response = await apiGetAuth(API_SETTING.GENERAL_SETTING, payload)
      context.commit('SET_GENERAL_SETTING', response.data.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async updateGeneralSetting (context, payload) {
    try {
      console.log(payload)
      const response = await apiPutAuth(API_SETTING.UPDATE_GENERAL_SETTING, payload)
      console.log(response)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '', 
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  }
}

const getters = {
  general_setting (state) {
    return state.general_setting
  },
  get_data_modal_add_edit (state) {
    return state.data_modal_add_edit
  },
  get_toggle_modal_add_edit_discard (state) {
    return state.toggle_modal_add_edit_discard
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
